var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMileage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_258_60770",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_258_60770)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.83647 12.7885C9.13244 13.0844 9.51362 13.2249 9.98001 13.21C10.4463 13.195 10.7884 13.0267 11.0065 12.7052L15.5288 6.15396L8.96147 10.6602C8.63466 10.8783 8.45814 11.2135 8.43189 11.6658C8.40577 12.1183 8.54064 12.4926 8.83647 12.7885ZM10 3.75C10.7928 3.75 11.5356 3.85389 12.2283 4.06167C12.9213 4.26944 13.5904 4.58382 14.2356 5.00479L13.0608 5.76438C12.5865 5.51229 12.0949 5.32188 11.5858 5.19313C11.0767 5.06438 10.5481 5 10 5C8.15279 5 6.57987 5.64931 5.28126 6.94792C3.98265 8.24653 3.33334 9.81944 3.33334 11.6667C3.33334 12.25 3.4132 12.8264 3.57293 13.3958C3.73265 13.9653 3.95834 14.5 4.25001 15H15.75C16.0695 14.4722 16.3021 13.9236 16.4479 13.3542C16.5938 12.7847 16.6667 12.1944 16.6667 11.5833C16.6667 11.0833 16.605 10.5772 16.4817 10.065C16.3582 9.55264 16.1677 9.06625 15.9102 8.60583L16.6698 7.43104C17.0812 8.10521 17.3897 8.77965 17.5954 9.45437C17.801 10.1291 17.9081 10.8302 17.9167 11.5577C17.9252 12.312 17.8402 13.0249 17.6619 13.6962C17.4834 14.3678 17.2147 15.0246 16.8558 15.6667C16.7457 15.8472 16.5908 15.9896 16.3911 16.0937C16.1912 16.1979 15.9775 16.25 15.75 16.25H4.25001C4.02779 16.25 3.81814 16.1966 3.62105 16.0898C3.42397 15.9828 3.26501 15.8311 3.14418 15.6346C2.82584 15.079 2.56945 14.4733 2.37501 13.8173C2.18057 13.1613 2.08334 12.4444 2.08334 11.6667C2.08334 10.5781 2.28987 9.55465 2.70293 8.59646C3.11598 7.63826 3.6798 6.79903 4.39439 6.07875C5.10911 5.35847 5.94932 4.79028 6.91501 4.37417C7.88084 3.95806 8.90918 3.75 10 3.75Z",
    fill: "#3F3F46"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMileage);
export default __webpack_public_path__ + "static/media/Mileage.3d62decad672beb7bd4a67bffd81710e.svg";
export { ForwardRef as ReactComponent };